import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';
import type { DateRange } from '../../common/types.tsx';
import { isDateRangeSame } from '../../common/utils/date-range.tsx';

export type State = {
	selectedRange: DateRange | null;
};

export const initialState: State = {
	selectedRange: null,
};

export const actions = {
	setSelectedRange:
		(range: DateRange): Action<State> =>
		({ getState, setState }) => {
			const { selectedRange: previousRange } = getState();

			if (previousRange === null || !isDateRangeSame(previousRange, range)) {
				setState({
					selectedRange: range,
				});
			}
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'SelectedDateRangeStore',
	initialState,
	actions,
});

export const useSelectedRange = createHook(Store, {
	selector: (state) => state.selectedRange,
});
